import { FC, useState } from "react";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
} from "react-share";
import classNames from "classnames/bind";

import FacebookIcon from "components/Icons/icons/24/facebook.svg";
import LinkdinIcon from "components/Icons/icons/24/linkdin.svg";
import TwitterIcon from "components/Icons/icons/24/twitter.svg";
import CopyIcon from "components/Icons/icons/24/copy.svg";
import { Icon } from "components/Icons";
import { Toast } from "components/Toast";

import { SharingProps } from "./Sharing.types";
import styles from "./Sharing.module.scss";
import content from "./content";

const cx = classNames.bind(styles);

export const Sharing: FC<SharingProps> = ({
    link,
    language,
    title,
    description,
}) => {
    const { toastText } = content(language);

    const [showToast, setShowToast] = useState(false);

    const copyText = () => {
        const temp = document.createElement("input");

        document.body.appendChild(temp);
        temp.value = link;
        temp.select();
        document.execCommand("copy");
        document.body.removeChild(temp);
        setShowToast(true);

        const timeout = setTimeout(() => setShowToast(false), 1600);

        return () => clearTimeout(timeout);
    };

    return (
        <div className={cx("root")}>
            <div className={cx("button")}>
                <FacebookShareButton url={link} quote={title}>
                    <Icon>
                        <FacebookIcon />
                    </Icon>
                </FacebookShareButton>
            </div>
            <div className={cx("button")}>
                <LinkedinShareButton
                    url={link}
                    title={title}
                    summary={description}
                >
                    <Icon>
                        <LinkdinIcon />
                    </Icon>
                </LinkedinShareButton>
            </div>
            <div className={cx("button")}>
                <TwitterShareButton url={link} title={title}>
                    <Icon>
                        <TwitterIcon />
                    </Icon>
                </TwitterShareButton>
            </div>
            <div className={cx("button", "button_copy")}>
                <button className={cx("copy")} onClick={copyText}>
                    <Icon>
                        <CopyIcon />
                    </Icon>
                </button>
                <Toast
                    className={cx("toast", {
                        toast_visible: showToast,
                    })}
                >
                    {toastText}
                </Toast>
            </div>
        </div>
    );
};
